/*
  Footer contact buttons — the bridge to Shopify Inbox.

  Companion to section 11 of assets/wildfang.css, which retires the two floating
  launchers (Dondy WhatsApp and Shopify Inbox). WhatsApp needs nothing from this
  file: the footer renders a plain wa.me link, so that channel works with the
  Dondy widget hidden and would keep working if the app were uninstalled
  entirely. Inbox is different — it is a JS widget with no public API, so the
  only way to open it is to click the button inside its shadow root.

  <shopify-chat> exposes an OPEN shadow root and marks that button
  part="activator", so reaching it is supported rather than a hack.

  THE HONEST CAVEAT. Clicking the activator produces no observable change in
  headless Firefox — no DOM mutation, no popup, no navigation — so the panel
  could not be confirmed to open in testing. It may need a trusted event, or a
  session this environment does not have. Everything below is therefore built to
  DEGRADE GRACEFULLY rather than to assume success:

    - The footer chat button stays `hidden` until <shopify-chat> is confirmed
      present, so the store never shows a button that cannot open anything.
      Where it is the contact group's only channel (no WhatsApp number — the
      case on wildfangpet.com), sections/footer.liquid hides the whole group
      with it, so the heading is revealed together with the button or not at all.
    - Clicking it FIRST un-hides the real Inbox launcher (by adding
      .wf-contact-show-chat to <html>), THEN forwards the click. If the
      forwarded click silently fails, the genuine launcher is now on screen at
      the bottom right for the visitor to press. The worst case is one extra
      click, never a dead end.
    - Once revealed, the launcher stays revealed for the rest of the page view.
      Someone who has asked to chat has earned the persistent affordance.
    - If <shopify-chat> is on the page but its activator never becomes
      reachable within the polling window (a slow connection, a closed or
      restructured shadow root), the real launcher is revealed instead. Section
      11 hides it only because the footer button can open it; when the footer
      button never appears, hiding the launcher as well would leave no way into
      the chat at all.

  If you later confirm the forwarded click works, nothing needs changing; the
  reveal is harmless. If you confirm it does NOT, delete the forwarding line and
  the reveal alone still gets the visitor to a working chat.
*/
(function () {
  'use strict';

  var SHOW_CLASS = 'wf-contact-show-chat';

  function activator() {
    var host = document.querySelector('shopify-chat');
    if (!host || !host.shadowRoot) return null;
    return host.shadowRoot.querySelector('button.activator, [part~="activator"]');
  }

  /* Section 11 hides the launcher with `html:not(.wf-contact-show-chat)`, so
     the default state needs no class and cannot flash before this file runs.
     Revealing is therefore an add, and it is deliberately not undone: someone
     who has asked to chat keeps the affordance for the rest of the page view. */
  function revealLauncher() {
    document.documentElement.classList.add(SHOW_CLASS);
  }

  /* Un-hides every footer chat button, plus the contact group around it where
     sections/footer.liquid hid the group because chat is its only channel.
     Queried fresh on every call: a theme-editor re-render replaces the nodes. */
  function revealButtons() {
    var buttons = document.querySelectorAll('[data-wf-chat]');
    for (var i = 0; i < buttons.length; i++) {
      buttons[i].hidden = false;
      var group = buttons[i].closest('[data-wf-chat-only]');
      if (group) group.hidden = false;
    }
  }

  /* Delegated: the footer button is in the DOM at parse time, but delegating
     costs nothing and survives a section re-render from the theme editor. */
  document.addEventListener('click', function (event) {
    if (!event.target.closest) return;
    var trigger = event.target.closest('[data-wf-chat]');
    if (!trigger) return;

    event.preventDefault();
    revealLauncher();

    var button = activator();
    if (button) button.click();
  });

  /* Show the footer chat button only once Inbox is actually on the page. The
     widget mounts a couple of seconds after load, so poll briefly rather than
     deciding at parse time. Give up after 20s: if Inbox has not appeared by
     then it is blocked, disabled, or the visitor declined consent, and a chat
     button that opens nothing is worse than no chat button. If the
     <shopify-chat> host IS there, hand the visitor Inbox's own launcher rather
     than nothing — see the last caveat above. */
  var poll = null;

  function watchForInbox() {
    if (!document.querySelector('[data-wf-chat]')) return;

    clearInterval(poll);
    var waited = 0;
    poll = setInterval(function () {
      waited += 500;
      if (activator()) {
        clearInterval(poll);
        revealButtons();
      } else if (waited >= 20000) {
        clearInterval(poll);
        if (document.querySelector('shopify-chat')) revealLauncher();
      }
    }, 500);
  }

  watchForInbox();

  /* The theme editor re-renders the footer on every setting change, and the new
     markup arrives with the button (and a chat-only group) hidden again, long
     after the poll above has stopped. Look again whenever a section reloads; with
     Inbox already mounted that is a single 500ms tick. */
  document.addEventListener('shopify:section:load', watchForInbox);
})();
